import { Table } from "antd";
import React, { Component } from "react";
import { getEmployees } from "../../actions/OrganizationAction";
import SearchEmployeesForm from "../form/SearchEmployeesForm";
import { isAlive } from "../../util";

class EmployeeTable extends Component {
    state = {
    	employees: [],
    	page: 1,
    	per_page: 10,
    	total: 0,
    	sorter: {},
    	search: {},
    }
    constructor(props){
    	super(props);
    	const { employee, employeeMeta } = props;
    	if(employeeMeta){
    		this.state = {...this.state, ...this.toPaginationStateValue(employeeMeta)};
    	}
    	this.state.employees = employee;
    }
    componentWillReceiveProps(props){
    	const { employee, employeeMeta } = props;
    	let combineStateChange = {};
    	if(employee){
    		combineStateChange = {employee};
    		this.setState({employee});
    	}
    	if(employeeMeta){
    		combineStateChange = {
    			...combineStateChange, 
    			...this.toPaginationStateValue(employeeMeta)
    		};
    	}
    	if(Object.keys(combineStateChange).length > 0){
    		this.setState(combineStateChange);
    	}
    }
    componentDidMount() {
    	// console.log("EmployeeTable.props: ", this.props);
    	const { autoQuery } = this.props;
    	if(autoQuery){
    		this.getEmp();
    	}
    }
    toPaginationStateValue(employeeMeta){
    	const { pagination } = employeeMeta;
    	if (pagination) {
    		const { current_page, per_page, total } = pagination;
    		return { page:current_page, per_page, total };
    		// if (callback) callback({total})
    	}
    	const { page, per_page, total } = this.state;
    	return { page, per_page, total };
    }
    getEmp = (search = {}) => {
    	const { searchEmployee } = this.props;
    	this.setState({ search }, () => {
    		const { per_page, page, sorter } = this.state;
    		const { setActiveEmployeeLength, sortPin = false /*, callback */ } = this.props;
    		const newSorter = sortPin ? { field: "support_pin", order: "ascend" } : { ...sorter };
    		searchEmployee({ active: "active", page, per_page, ...search, ...newSorter }).then(res => {
    			console.log("res", {res, search, sorter});
    			const { pagination, active_employees, employees } = res;
    			if (employees) this.setState({ employees });
    			if (active_employees && setActiveEmployeeLength) setActiveEmployeeLength(active_employees);
    			if (pagination) {
    				const { total } = pagination;
    				this.setState({ total });
    				// if (callback) callback({total})
    			}
    		});
    	});
    }

    handleTableChange = (pagination, filters, sorter) => {
    	// console.log("handleTableChange: ",{pagination, filters, sorter});
    	const { current, pageSize } = pagination;
    	const { order, field } = sorter;
    	const { search } = this.state;
    	this.setState({ page: current, per_page: pageSize, sorter: { order, field } },
    		() => this.getEmp(search));
    }

    rowSelection = {
    	onChange: (selectedRowKeys, selectedRows) => {
    		const { setSelectedRows } = this.props;
    		if (setSelectedRows) setSelectedRows(selectedRows);
    	}
    }

    render() {
    	const { employees, total, per_page, active_employees } = this.state;
    	const { choice, category_title, loading, columns, setSelectedRows,
    		disableSearchEmail = false,
    		onRowClick, search, showCategory
    	} = this.props;
    	const rowSelection = setSelectedRows ? { rowSelection: this.rowSelection } : {};
	
    	return (
    		<div>
    			{search ? <SearchEmployeesForm
    				disableSearchEmail={disableSearchEmail}
    				onSubmitSearch={this.getEmp}
    				showCategory={showCategory}
    				choice={choice}
    				category_title={category_title} /> : undefined}
    			<Table
    				onChange={this.handleTableChange}
    				onRow={(record) => {
    					return {
    						style:{cursor:"pointer"},
    						onClick: () => onRowClick ? onRowClick(record) : {},
    					};
    				}}
    				pagination={{
    					showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    					pageSize: per_page,
    					showSizeChanger: true,
    					pageSizeOptions: ["10", "20", "30", "40"],
    					total,
    				}}
    				rowKey={record =>{
    					if(isAlive(record.user_id)){
    						return record.user_id;
    					}
    					return record.id;
    				}}
    				columns={columns}
    				dataSource={employees}
    				size="small"
    				loading={loading}
    				{...rowSelection} />
    		</div>
    	);
    }
}
EmployeeTable.defaultProps = {
	autoQuery:true,
	employee:[],
	employeeMeta:undefined,
	search: true,
	searchEmployee: getEmployees,
};
export default EmployeeTable;


// WEBPACK FOOTER //
// ./src/components/table/EmployeeTable.js